/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetVideoRecorderFileParams,
  SchemaValidationErrorResponse,
  VideoRecorderFile,
  VideoRecorderInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create File
 */
export const createVideoRecorderFile = (

 signal?: AbortSignal
) => {


      return axiosClient<VideoRecorderFile>(
      {url: `/video_recorder/files`, method: 'POST', signal
    },
      );
    }




export const getCreateVideoRecorderFileMutationKey = () => ['createVideoRecorderFile'] as const;

export const getCreateVideoRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoRecorderFile>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVideoRecorderFile>>, TError,void, TContext> => {

const mutationKey = getCreateVideoRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideoRecorderFile>>, void> = () => {


          return  createVideoRecorderFile()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof createVideoRecorderFile>>>

    export type CreateVideoRecorderFileMutationError = ErrorType<void>


    /**
 * @summary Create File
 */
export const useCreateVideoRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoRecorderFile>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVideoRecorderFile>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateVideoRecorderFileMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Video Recorder File
 */
export const deleteVideoRecorderFile = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/video_recorder/files/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteVideoRecorderFileMutationKey = () => ['deleteVideoRecorderFile'] as const;

export const getDeleteVideoRecorderFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, TError,DeleteVideoRecorderFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, TError,DeleteVideoRecorderFileMutationVariables, TContext> => {

const mutationKey = getDeleteVideoRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, DeleteVideoRecorderFileMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteVideoRecorderFile(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVideoRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVideoRecorderFile>>>

    export type DeleteVideoRecorderFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteVideoRecorderFileMutationVariables = {id: string}

    /**
 * @summary Delete Video Recorder File
 */
export const useDeleteVideoRecorderFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, TError,DeleteVideoRecorderFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteVideoRecorderFile>>,
        TError,
        DeleteVideoRecorderFileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteVideoRecorderFileMutationOptions(options), queryClient);
    }
    /**
 * @summary Show File
 */
export const getVideoRecorderFile = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetVideoRecorderFileParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<VideoRecorderFile>(
      {url: `/video_recorder/files/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetVideoRecorderFileQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetVideoRecorderFileParams>,) => {
    return [
    'video_recorder','files',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVideoRecorderFileQueryOptions = <TData = Awaited<ReturnType<typeof getVideoRecorderFile>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetVideoRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoRecorderFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetVideoRecorderFileQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVideoRecorderFile>>> = ({ signal }) => getVideoRecorderFile(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVideoRecorderFile>>, TError, TData>
}

export type GetVideoRecorderFileQueryResult = NonNullable<Awaited<ReturnType<typeof getVideoRecorderFile>>>
export type GetVideoRecorderFileQueryError = ErrorType<void>


/**
 * @summary Show File
 */

export function useGetVideoRecorderFile<TData = Awaited<ReturnType<typeof getVideoRecorderFile>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetVideoRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVideoRecorderFile>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVideoRecorderFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update File
 */
export const updateVideoRecorderFile = (
    id: MaybeRefOrGetter<string>,
    videoRecorderInput: MaybeRefOrGetter<VideoRecorderInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
videoRecorderInput = toValue(videoRecorderInput);

      return axiosClient<VideoRecorderFile>(
      {url: `/video_recorder/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: videoRecorderInput, signal
    },
      );
    }




export const getUpdateVideoRecorderFileMutationKey = () => ['updateVideoRecorderFile'] as const;

export const getUpdateVideoRecorderFileMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideoRecorderFile>>, TError,UpdateVideoRecorderFileMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVideoRecorderFile>>, TError,UpdateVideoRecorderFileMutationVariables, TContext> => {

const mutationKey = getUpdateVideoRecorderFileMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVideoRecorderFile>>, UpdateVideoRecorderFileMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateVideoRecorderFile(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVideoRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateVideoRecorderFile>>>
    export type UpdateVideoRecorderFileMutationBody = VideoRecorderInput
    export type UpdateVideoRecorderFileMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateVideoRecorderFileMutationVariables = {id: string;data: VideoRecorderInput}

    /**
 * @summary Update File
 */
export const useUpdateVideoRecorderFile = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideoRecorderFile>>, TError,UpdateVideoRecorderFileMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVideoRecorderFile>>,
        TError,
        UpdateVideoRecorderFileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVideoRecorderFileMutationOptions(options), queryClient);
    }
